import { CircularProgress, IconButton, styled } from '@mui/material';

interface AdditionalIconButtonStyledProps {
  $size: number;
  $fullWidth: boolean;
}

export const LOADER_SIZE = 1.6;

const BaseIconButtonStyled = styled(
  IconButton
)<AdditionalIconButtonStyledProps>(({ theme, $size, $fullWidth }) => ({
  height: `${$size + 2 * theme.spacingUnitless(1)}rem`,
  width: $fullWidth
    ? '100%'
    : `${$size + 3 * theme.spacingUnitless(1) + LOADER_SIZE}rem`,
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.primary.main,
  '.MuiTouchRipple-child': {
    borderRadius: theme.shape.borderRadius,
  },
}));

export const PrimaryIconButtonStyled = styled(BaseIconButtonStyled)(
  ({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:disabled': {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.grey[400],
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&:focus': {
      outline: `0.2rem solid ${theme.palette.primary.main}`,
    },
    '.MuiTouchRipple-child': {
      backgroundColor: theme.palette.primary.pressed,
    },
  })
);

export const SecondaryIconButtonStyled = styled(BaseIconButtonStyled)(
  ({ theme }) => ({
    border: `0.1rem solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '&:disabled': {
      border: `0.1rem solid ${theme.palette.grey[400]}`,
      color: theme.palette.grey[400],
    },
    '&:focus': {
      outline: `0.2rem solid ${theme.palette.primary.main}`,
    },
    '.MuiTouchRipple-child': {
      backgroundColor: theme.palette.grey[200],
    },
  })
);

export const TertiaryIconButtonStyled = styled(BaseIconButtonStyled)(
  ({ theme }) => ({
    color: theme.palette.primary.main,
    '&:disabled': {
      color: theme.palette.grey[400],
    },
    '&:focus': {
      backgroundColor: theme.palette.grey[200],
    },
    '.MuiTouchRipple-child': {
      backgroundColor: theme.palette.grey[200],
    },
  })
);

export const CircularProgressStyled = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.primaryDark.main,
}));
